import { blackGreen, blue, gold, grey, orange, textMuted, white } from '@/theme/colors'
import { fontBody, fontDisplay } from '@/theme/fonts'
import styled from 'styled-components'

// Deterministic avatar backgrounds — the backend does not store a per-user
// colour, so we cycle a fixed brand palette by position. Shared so other bento
// surfaces (e.g. the money tile's balance lines) colour avatars identically.
const PALETTE = [orange, gold, blue, blackGreen]
export const avatarColorForIndex = (index: number): string => PALETTE[index % PALETTE.length]

export const StackRoot = styled.button<{ $gap: number; $interactive: boolean }>`
	display: inline-flex;
	align-items: center;
	gap: ${({ $gap }) => $gap}px;
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	font: inherit;
	color: inherit;
	cursor: ${({ $interactive }) => ($interactive ? 'pointer' : 'default')};

	&:focus-visible {
		outline: 2px solid ${textMuted};
		outline-offset: 3px;
		border-radius: 4px;
	}
`

export const AvatarRow = styled.span`
	display: inline-flex;
`

export const AvatarCircle = styled.span<{ $size: number; $index: number; $bg: string }>`
	width: ${({ $size }) => $size}px;
	height: ${({ $size }) => $size}px;
	border-radius: 999px;
	border: 2px solid ${white};
	background: ${({ $bg }) => $bg};
	color: ${white};
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: ${({ $size }) => Math.round($size * 0.4)}px;
	line-height: 1;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	flex-shrink: 0;
	margin-left: ${({ $index, $size }) => ($index ? -Math.round($size * 0.3) : 0)}px;
`

export const AvatarImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
`

export const MoreBubble = styled(AvatarCircle)`
	background: ${grey};
	color: ${textMuted};
`

export const FriendsCaption = styled.span`
	font-family: ${fontBody};
	font-size: 14px;
	color: ${textMuted};
	white-space: nowrap;
`
